<div class="message-container">
  <div class="message-card">
    <div class="card-header">
      <div class="header-icon">
        <i class="fa-solid fa-plus"></i>
      </div>
      <h2 class="card-title">New Message Setup</h2>
    </div>

    <form [formGroup]="messageForm" (ngSubmit)="onSubmit()" class="message-form">
      <!-- Mobile Number -->
      <div class="form-row">
        <div class="form-group full">
          <label for="number">Mobile Number</label>
          <div class="input-wrapper">
            <div class="input-icon">
              <i class="fa-solid fa-phone"></i>
            </div>
            <input
              type="tel"
              id="number"
              formControlName="number"
              placeholder="Enter mobile number"
            />
          </div>
        </div>
      </div>

      <!-- Package Selection Cards -->
      <div class="selection-section">
        <label for="packagePlan">Select Package Plan</label>
        <div class="cards-grid">
          @for (pkg of packages(); track pkg.name) {
            <button
              type="button"
              class="selection-card"
              [class.active]="messageForm.get('package')?.value.name === pkg.name"
              (click)="selectPackage(pkg)"
            >
              <div class="card-check">
                <i class="fa-solid fa-check"></i>
              </div>
              <div class="card-content">
                <span class="pkg-name">{{ pkg.name }}</span>
                <span class="pkg-sub">Active</span>
              </div>
            </button>
          }
        </div>
      </div>

      <!-- Sender ID Selection Cards -->
      <div class="selection-section">
        <label for="senderId">Select Sender ID</label>
        <div class="cards-grid">
          @for (id of senderIds(); track id) {
            <button
              type="button"
              class="selection-card sender-card"
              [class.active]="messageForm.get('senderId')?.value === id"
              (click)="selectSenderId(id)"
            >
              <div class="card-check">
                <i class="fa-solid fa-check"></i>
              </div>
              <div class="card-content">
                <span class="sender-name">{{ id }}</span>
                <span class="sender-sub">Verified</span>
              </div>
            </button>
          }
        </div>
      </div>

      <!-- Message Text -->
      <div class="form-group full">
        <label for="messageText">Message Text</label>
        <div class="textarea-container">
          <textarea
            id="messageText"
            formControlName="messageText"
            placeholder="Enter your message here..."
            rows="4"
          ></textarea>
          <div class="textarea-stats">
            <span>Total Messages: {{ messageCount }}</span>
            <span>Total characters: {{ charCount }}</span>
          </div>
        </div>
      </div>

      <!-- Footer Action Bar -->
      <div class="form-footer-bar">
        <div class="total-info">
          <span class="total-label">TOTAL COST</span>
          <span class="total-value">{{ messageCost }} ฿</span>
        </div>
        <button type="submit" class="btn-confirm" [disabled]="messageForm.invalid">
          <i class="fa-solid fa-circle-check"></i>
          Confirm & Send
        </button>
      </div>
    </form>
  </div>
</div>
